import * as type from '../../types';


const initialChangePassordState = {
    response : {},
    loading:false,
    error:null
}
export const changePasswordReducer = (state = initialChangePassordState, action) => {
    switch (action.type) {
        case type.CHANGE_PASSWORD_REQUEST:
            return {
                ...state,
                loading: true
            };
        case type.CHANGE_PASSWORD_SUCCESS:
            return {
                ...state,
                loading: false,
                response: action.data
            };
        case type.CHANGE_PASSWORD_FAILURE:
            return {
                ...state,
                loading: false,
                response: action.message
            };
        default:
            return state;
    }
};
